import { ExtractlyOfficeApiError } from '../types/errors'

export abstract class ExtractlyOfficeApiErrorClass extends Error {
  abstract readonly code: ExtractlyOfficeApiError

  constructor(message: string) {
    super(message)
    this.name = this.constructor.name
    Object.setPrototypeOf(this, new.target.prototype)
  }
}

export class ExtractlyOfficeApiAccessDeniedError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'AccessDenied'
}

export class ExtractlyOfficeApiActivityLimitReachedError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'ActivityLimitReached'
}

export class ExtractlyOfficeApiApiNotAvailableError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'ApiNotAvailable'
}

export class ExtractlyOfficeApiApiNotFoundError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'ApiNotFound'
}

export class ExtractlyOfficeApiBadPasswordError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'BadPassword'
}

export class ExtractlyOfficeApiConflictError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'Conflict'
}

export class ExtractlyOfficeApiContentLengthRequiredError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'ContentLengthRequired'
}

export class ExtractlyOfficeApiEmptyChartSeriesError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'EmptyChartSeries'
}

export class ExtractlyOfficeApiFilteredRangeConflictError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'FilteredRangeConflict'
}

export class ExtractlyOfficeApiFormulaLengthExceedsLimitError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'FormulaLengthExceedsLimit'
}

export class ExtractlyOfficeApiGeneralExceptionError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'GeneralException'
}

export class ExtractlyOfficeApiHostRestartNeededError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'HostRestartNeeded'
}

export class ExtractlyOfficeApiInactiveWorkbookError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InactiveWorkbook'
}

export class ExtractlyOfficeApiInsertDeleteConflictError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InsertDeleteConflict'
}

export class ExtractlyOfficeApiInvalidArgumentError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InvalidArgument'
}

export class ExtractlyOfficeApiInvalidBindingError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InvalidBinding'
}

export class ExtractlyOfficeApiInvalidOperationError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InvalidOperation'
}

export class ExtractlyOfficeApiInvalidOperationInCellEditModeError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InvalidOperationInCellEditMode'
}

export class ExtractlyOfficeApiInvalidReferenceError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InvalidReference'
}

export class ExtractlyOfficeApiInvalidRequestError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InvalidRequest'
}

export class ExtractlyOfficeApiInvalidRibbonDefinitionError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InvalidRibbonDefinition'
}

export class ExtractlyOfficeApiInvalidSelectionError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'InvalidSelection'
}

export class ExtractlyOfficeApiItemAlreadyExistsError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'ItemAlreadyExists'
}

export class ExtractlyOfficeApiItemNotFoundError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'ItemNotFound'
}

export class ExtractlyOfficeApiMemoryLimitReachedError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'MemoryLimitReached'
}

export class ExtractlyOfficeApiMergedRangeConflictError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'MergedRangeConflict'
}

export class ExtractlyOfficeApiNonBlankCellOffSheetError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'NonBlankCellOffSheet'
}

export class ExtractlyOfficeApiNotImplementedError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'NotImplemented'
}

export class ExtractlyOfficeApiOperationCellsExceedLimitError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'OperationCellsExceedLimit'
}

export class ExtractlyOfficeApiPivotTableRangeConflictError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'PivotTableRangeConflict'
}

export class ExtractlyOfficeApiRangeExceedsLimitError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'RangeExceedsLimit'
}

export class ExtractlyOfficeApiRefreshWorkbookLinksBlockedError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'RefreshWorkbookLinksBlocked'
}

export class ExtractlyOfficeApiRequestAbortedError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'RequestAborted'
}

export class ExtractlyOfficeApiRequestPayloadSizeLimitExceededError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'RequestPayloadSizeLimitExceeded'
}

export class ExtractlyOfficeApiResponsePayloadSizeLimitExceededError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'ResponsePayloadSizeLimitExceeded'
}

export class ExtractlyOfficeApiServiceNotAvailableError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'ServiceNotAvailable'
}

export class ExtractlyOfficeApiUnauthenticatedError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'Unauthenticated'
}

export class ExtractlyOfficeApiUndoNotSupportedError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'UndoNotSupported'
}

export class ExtractlyOfficeApiUnsupportedFeatureError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'UnsupportedFeature'
}

export class ExtractlyOfficeApiUnsupportedOperationError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'UnsupportedOperation'
}

export class ExtractlyOfficeApiUnsupportedSheetError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'UnsupportedSheet'
}

export class ExtractlyOfficeApiUnknownError extends ExtractlyOfficeApiErrorClass {
  readonly code = 'UnknownError'
}
